import * as React from 'react';

import './ResultListHeader.css';

interface IProps {
  query: string,
  isLoading: boolean,
  resultCount: number | null,
}

const ResultListHeader: React.SFC<IProps> = ({
  query,
  isLoading,
  resultCount,
}) => {
    let name = '';
    if (query) {
      name = `Showing results for '${query}'`;
    }
    if (isLoading) {
      name += '...';
    }

    return (
      <div className="result-list-header">
        <span className="result-name">{name}</span>
        {
          resultCount !== null
          ? (<span className="result-summary">{ resultCount.toLocaleString() } total</span>)
          : null
        }
      </div>
    );
}

export default ResultListHeader;



// WEBPACK FOOTER //
// ./src/components/ResultListHeader.tsx